import * as _ from "lodash-es";
import React, { ChangeEvent, Component } from "react";
import Modal from "react-modal";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetLotsDTO from "../../../models/DTO/IGetLotsDTO";
import IGetPickListItemDTO from "../../../models/DTO/IGetPickListItemDTO";
import IOnGetLotsDTO from "../../../models/DTO/IOnGetLotsDTO";
import IOnGetPickListItemDTO from "../../../models/DTO/IOnGetPickListItemDTO";
import IOnUpdatePickListItemDTO from "../../../models/DTO/IOnUpdatePickListItemDTO";
import IUpdatePickListItemDTO from "../../../models/DTO/IUpdatePickListItemDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import ILot from "../../../models/ILot";
import INewPick_List_Item_Lot_Map from "../../../models/INewPick_List_Item_Lot_Map";
import INotification from "../../../models/INotification";
import IPick_List from "../../../models/IPick_List";
import IPick_List_Catalog_Item_Detail from "../../../models/IPick_List_Catalog_Item_Detail";
import IPick_List_Item_Lot_Map from "../../../models/IPick_List_Item_Lot_Map";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import UserService from "../../../services/UserService";
import OwButton from "../../shared/OwButton/OwButton";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import { OwItemPickStatus } from "../../shared/OwItemPickStatus/OwItemPickStatus";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import PickListItemDetailIssueModal from "../PickListItemDetailIssueModal/PickListItemDetailIssueModal";
import PickListItemDetailWarningModal from "../PickListItemDetailWarningModal/PickListItemDetailWarningModal";
import "./PickListItemDetail.scss";
import { Socket } from "socket.io-client";
import { MobilePlusMinusInput } from "../../shared/MobilePlusMinusInput/MobilePlusMinusInput";

type Props = {
    history: any;
    location: any;
    match: any;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    setActivityIndicator: (activityIndicator: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    item: IPick_List_Catalog_Item_Detail;
    closeFn: (refreshData?: boolean, openDiffItem?: IPick_List_Catalog_Item_Detail) => void;
    scanMode: boolean;
    pickList: IPick_List;
    incrementOnLoad?: boolean;
    readOnly: boolean;
};

type State = {
    saveActive: boolean;
    pickListItem: IPick_List_Catalog_Item_Detail;
    pickListGuid: string;
    modalComponent: any;
    modalIsOpen: boolean;
    capturedScanValue: string;
    openDiffItem?: IPick_List_Catalog_Item_Detail;
    lots?: ILot[];
    lotsLimit: number;
    lotsOffset: number;
};

class PickListItemDetail extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            saveActive: false,
            pickListGuid: this.props.match.params.guid,
            pickListItem: this.props.item,
            modalComponent: null,
            modalIsOpen: false,
            capturedScanValue: "",
            lots: [],
            lotsLimit: 10,
            lotsOffset: 0,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.PickListOnGetPickListItem, this.onGetPickListItem);
        this.props.socket.on(EndpointsEnum.PickListOnUpdatePickListItem, this.onUpdatePickListItem);
        this.props.socket.on(EndpointsEnum.CatalogItemOnGetLots, this.onGetLots);

        this.getPickListItem();

        document.addEventListener("keydown", this.keyboardListener);
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.PickListOnGetPickListItem, this.onGetPickListItem);
        this.props.socket.removeListener(EndpointsEnum.PickListOnUpdatePickListItem, this.onUpdatePickListItem);
        this.props.socket.removeListener(EndpointsEnum.CatalogItemOnGetLots, this.onGetLots);

        document.removeEventListener("keydown", this.keyboardListener);
    }

    keyboardListener = (e: KeyboardEvent) => {
        if (this.props.scanMode) {
            console.log("keyboardListener: ", e);
            // ignore the following key events
            switch (e.key) {
                case "Shift":
                case "Unidentified":
                    return;

                case "Enter":
                    this.processCapturedScanValue();
                    return;
            }

            this.setState({
                capturedScanValue: `${this.state.capturedScanValue}${e.key}`,
            });
        }
    };

    processCapturedScanValue = () => {
        const capturedScanValue = this.state.capturedScanValue;

        console.log("processCapturedScanValue: ", capturedScanValue);

        if (capturedScanValue.length) {
            // process the scan

            this.setState(
                {
                    capturedScanValue: "",
                },
                () => {
                    const notification: INotification = {
                        message: "scan_captured",
                        level: NotificationLevelEnum.success,
                        position: NotificationPositionEnum.bc,
                        clearExisting: true,
                    };

                    this.props.notifyFn(null, notification);

                    if (this.props.pickList?.Catalog_Items && !this.state.modalIsOpen) {
                        if (capturedScanValue === this.state.pickListItem.sku || capturedScanValue === this.state.pickListItem.upc) {
                            this.incrementQty();
                        } else {
                            for (const item of this.props.pickList.Catalog_Items) {
                                if (item.sku === capturedScanValue || item.upc === capturedScanValue) {
                                    // save and close the item, and open a modal for the different item.
                                    console.log("saveAndBack", item);
                                    this.saveAndBack(item);

                                    // this.openItem(item);
                                    // this.props.history.push(`/pick_lists/${this.state.pickListGuid}/item/${item.Pick_List_Catalog_Item_Map.id}`);
                                    break;
                                }
                            }
                        }
                    }
                    // this.search();
                }
            );
        } else {
            // error processing the captured scan value

            const notification: INotification = {
                message: "error_capturing_scan",
                level: NotificationLevelEnum.error,
                position: NotificationPositionEnum.bc,
            };

            this.props.notifyFn(null, notification);
        }
    };

    getPickListItem = () => {
        if (this.state.pickListItem) {
            const payload: IGetPickListItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                pickListGuid: this.state.pickListGuid,
                pickListItemId: Number(this.state.pickListItem.Pick_List_Catalog_Item_Map.id),
            };

            this.props.socket.emit(EndpointsEnum.PickListGetPickListItem, payload);

            this.props.setActivityIndicator(true);
        }
    };

    onGetPickListItem = (data: IOnGetPickListItemDTO) => {
        const pickListItem = data.pickListItem;

        this.setState(
            {
                pickListItem,
            },
            () => {
                if (this.props.incrementOnLoad) {
                    this.incrementQty();
                }

                if (this.state.pickListItem.has_lots) {
                    this.getLots();
                }

                this.props.setActivityIndicator(false);
            }
        );
    };

    isPartialPick = (): boolean => {
        let partialPick = false;

        if (this.state.pickListItem) {
            const qtyToPick = Number(this.state.pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick || 0);
            const qtyPicked = Number(this.state.pickListItem.Pick_List_Catalog_Item_Map.qty_picked || 0);
            const issueQty = Number(this.state.pickListItem.Pick_List_Catalog_Item_Map.issue_qty || 0);
            const issueReason = this.state.pickListItem.Pick_List_Catalog_Item_Map.issue_reason_id;

            if (issueReason && issueQty) {
                if (issueQty + qtyPicked !== qtyToPick) {
                    partialPick = true;
                }
            } else {
                if (qtyToPick !== qtyPicked) {
                    partialPick = true;
                }
            }
        }

        return partialPick;
    };

    saveAndBack = (openDiffItem?: IPick_List_Catalog_Item_Detail) => {
        if (this.state.pickListItem) {
            this.setState(
                {
                    openDiffItem,
                },
                () => {
                    if (this.isPartialPick()) {
                        const modalComponent = <PickListItemDetailWarningModal closeModal={this.closePartialPickModal} />;

                        this.setState({
                            modalComponent,
                            modalIsOpen: true,
                        });
                    } else {
                        this.executeSaveAndBack();
                    }
                }
            );
        }
    };

    closePartialPickModal = (markIssue?: boolean) => {
        this.setState(
            {
                modalComponent: null,
                modalIsOpen: false,
            },
            () => {
                if (markIssue) {
                    this.markIssue();
                } else {
                    this.executeSaveAndBack();
                }
            }
        );
    };

    executeSaveAndBack = () => {
        if (this.state.pickListItem) {
            const payload: IUpdatePickListItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                pickListGuid: this.state.pickListGuid,
                pickListItemId: this.state.pickListItem.Pick_List_Catalog_Item_Map.id,
                pickListDetail: {
                    qty_picked: this.state.pickListItem.Pick_List_Catalog_Item_Map.qty_picked,
                    issue_qty: this.state.pickListItem.Pick_List_Catalog_Item_Map.issue_qty,
                },
            };

            this.props.socket.emit(EndpointsEnum.PickListUpdatePickListItem, payload);

            this.setState({
                saveActive: true,
            });
        }
    };

    markIssue = () => {
        if (this.state.pickListItem) {
            const modalComponent = (
                <PickListItemDetailIssueModal
                    closeModalFn={this.closeModal}
                    socket={this.props.socket}
                    notifyFn={this.props.notifyFn}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    pickListItem={this.state.pickListItem}
                    pickListGuid={this.state.pickListGuid}
                    readOnly={this.props.readOnly}
                />
            );

            this.setState({
                modalComponent,
                modalIsOpen: true,
            });
        }
    };

    closeModal = (refreshData?: boolean) => {
        this.setState(
            {
                modalIsOpen: false,
                modalComponent: null,
            },
            () => {
                if (refreshData) {
                    this.getPickListItem();
                }
            }
        );
    };

    removeSubstitution = () => {
        if (this.state.pickListItem) {
            const payload: IUpdatePickListItemDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                pickListGuid: this.state.pickListGuid,
                pickListItemId: this.state.pickListItem.Pick_List_Catalog_Item_Map.id,
                pickListDetail: {
                    sub_catalog_item_id: null,
                    issue_qty: 0,
                },
            };

            this.props.socket.emit(EndpointsEnum.PickListUpdatePickListItem, payload);
        }
    };

    onUpdatePickListItem = (data: IOnUpdatePickListItemDTO) => {
        if (!this.state.modalIsOpen) {
            if (this.state.saveActive) {
                this.props.closeFn(true, this.state.openDiffItem);
                // this.props.history.push(`/pick_lists/${this.state.pickListGuid}`);
            } else {
                if (this.state.openDiffItem) {
                    console.log("openDiffItem:", this.state.openDiffItem);
                    this.props.closeFn(false, this.state.openDiffItem);
                } else {
                    this.getPickListItem();
                }
            }
        }
    };

    getLots = (name?: string) => {
        const payload: IGetLotsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            catalogItemGuid: this.state.pickListItem.guid,
            limit: this.state.lotsLimit,
            offset: this.state.lotsOffset,
        };

        this.props.socket.emit(EndpointsEnum.CatalogItemGetLots, payload);
    };

    onGetLots = (data: IOnGetLotsDTO) => {
        this.setState({
            lots: data.lots,
        });
    };

    getTotalQtyPicked = (): number => {
        if (this.state.pickListItem) {
            const substitutionQty = this.state.pickListItem?.Pick_List_Catalog_Item_Map.issue_qty || 0;
            const pickedQty = this.state.pickListItem.Pick_List_Catalog_Item_Map.qty_picked || 0;

            return substitutionQty + pickedQty;
        } else {
            return 0;
        }
    };

    getQtyStepValue = (): number => {
        let step = 1;

        // Get the step based on supplier's qty_precision
        if (this.props.supplierModel?.qty_precision !== undefined && this.props.supplierModel.qty_precision > 0) {
            switch (this.props.supplierModel.qty_precision) {
                case 1:
                    step = 0.1;
                    break;
                case 2:
                    step = 0.01;
                    break;
                case 3:
                    step = 0.001;
                    break;
                default:
                    step = 1;
                    break;
            }
        }

        return step;
    };

    incrementQty = () => {
        const pickListItem = this.state.pickListItem;

        if (pickListItem) {
            if (_.isNil(pickListItem.Pick_List_Catalog_Item_Map.qty_picked)) {
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = 0;
            }

            const pickedQty = this.getTotalQtyPicked();
            const step = this.getQtyStepValue();
            const maxQty = pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick;
            const newQty = pickedQty + step;

            if (newQty <= maxQty) {
                // Round to avoid floating point precision issues
                const precision = this.props.supplierModel?.qty_precision || 0;
                const multiplier = Math.pow(10, precision);
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked =
                    Math.round((pickListItem.Pick_List_Catalog_Item_Map.qty_picked + step) * multiplier) / multiplier;
            } else if (pickedQty < maxQty) {
                // If we can't add a full step but haven't reached max, go to max
                const issueQty = pickListItem.Pick_List_Catalog_Item_Map.issue_qty || 0;
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = maxQty - issueQty;
            } else {
                const notification: INotification = {
                    message: "maximum_qty_picked",
                    level: NotificationLevelEnum.warning,
                    position: NotificationPositionEnum.bc,
                };

                this.props.notifyFn(null, notification);
            }

            this.setState({
                pickListItem,
            });
        }
    };

    decrementQty = () => {
        const pickListItem = this.state.pickListItem;

        if (pickListItem) {
            if (_.isNil(pickListItem.Pick_List_Catalog_Item_Map.qty_picked)) {
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = 0;
            }

            const step = this.getQtyStepValue();
            const newQty = pickListItem.Pick_List_Catalog_Item_Map.qty_picked - step;

            if (newQty >= 0) {
                // Round to avoid floating point precision issues
                const precision = this.props.supplierModel?.qty_precision || 0;
                const multiplier = Math.pow(10, precision);
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = Math.round(newQty * multiplier) / multiplier;
            } else {
                // Can't go below 0, set to 0
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = 0;
            }

            this.setState({
                pickListItem,
            });
        }
    };

    handleTotalPicked = (e: ChangeEvent<any>) => {
        const pickListItem = this.state.pickListItem;

        const value = Number(e.target.value || "0");

        if (pickListItem) {
            if (value <= pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick && value >= 0) {
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = value;
            }

            if (value <= 0) {
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = 0;
            }

            if (value > pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick) {
                pickListItem.Pick_List_Catalog_Item_Map.qty_picked = pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick;
            }

            this.setState({
                pickListItem,
            });
        }
    };

    incrementSubQty = () => {
        const pickListItem = this.state.pickListItem;

        if (pickListItem) {
            if (_.isNil(pickListItem.Pick_List_Catalog_Item_Map.issue_qty)) {
                pickListItem.Pick_List_Catalog_Item_Map.issue_qty = 0;
            }

            const pickedQty = this.getTotalQtyPicked();

            if (pickedQty < pickListItem.Pick_List_Catalog_Item_Map.qty_to_pick) {
                pickListItem.Pick_List_Catalog_Item_Map.issue_qty++;
            }

            this.setState({
                pickListItem,
            });
        }
    };

    decrementSubQty = () => {
        const pickListItem = this.state.pickListItem;

        if (pickListItem) {
            if (_.isNil(pickListItem.Pick_List_Catalog_Item_Map.issue_qty)) {
                pickListItem.Pick_List_Catalog_Item_Map.issue_qty = 0;
            }

            if (pickListItem.Pick_List_Catalog_Item_Map.issue_qty > 0) {
                pickListItem.Pick_List_Catalog_Item_Map.issue_qty--;
            }

            this.setState({
                pickListItem,
            });
        }
    };

    addLot = (lot: ILot) => {
        const pickListItem = this.state.pickListItem;

        if (pickListItem.Pick_List_Catalog_Item_Map.order_item_id) {
            const pickListLotsMap = pickListItem.Pick_List_Catalog_Item_Map.Pick_List_Item_Lot_Maps || [];

            const newLotMap: INewPick_List_Item_Lot_Map = {
                lot_id: lot.id,
                catalog_item_id: pickListItem.Pick_List_Catalog_Item_Map.catalog_item_id,
                order_item_id: pickListItem.Pick_List_Catalog_Item_Map.order_item_id,
                pick_list_cat_item_map_id: pickListItem.Pick_List_Catalog_Item_Map.id,
                pick_list_id: pickListItem.Pick_List_Catalog_Item_Map.pick_list_id,
                qty: 1,
            };

            // we should actually SAVE the lot first, and then reload the item in the modal.

            pickListLotsMap.push(newLotMap as IPick_List_Item_Lot_Map);

            pickListItem.Pick_List_Catalog_Item_Map.Pick_List_Item_Lot_Maps = pickListLotsMap;
        }

        this.setState({
            pickListItem,
        });
    };

    removeLot = (lotMap: IPick_List_Item_Lot_Map) => {};

    canAddLot = (lot: ILot): boolean => {
        const pickListItem = this.state.pickListItem;

        let canAdd = true;

        // qty check
        if (lot.qty - (lot.qty_assigned || 0) === 0) {
            canAdd = false;
        }

        // existing lot check
        if (pickListItem.Pick_List_Catalog_Item_Map.Pick_List_Item_Lot_Maps) {
            for (const lotItemMap of pickListItem.Pick_List_Catalog_Item_Map.Pick_List_Item_Lot_Maps) {
                if (lotItemMap.lot_id === lot.id) {
                    canAdd = false;
                    break;
                }
            }
        }

        return canAdd;
    };

    render() {
        const totalPicked = this.getTotalQtyPicked();
        const qtyPicked = this.state.pickListItem?.Pick_List_Catalog_Item_Map.qty_picked || 0;
        const qtyToPick = this.state.pickListItem?.Pick_List_Catalog_Item_Map.qty_to_pick || 0;

        let location: any = (this.state.pickListItem?.Warehouse_Catalog_Items_Maps || []).map((warehouseMap) => {
            return (
                <div key={warehouseMap.guid}>
                    {warehouseMap.row} {warehouseMap.bin}
                </div>
            );
        });

        if (!this.state.pickListItem?.Warehouse_Catalog_Items_Maps?.length) {
            location = "--";
        }

        let hasSubstitution = false;
        let substitutionQty = 0;

        if (this.state.pickListItem?.Pick_List_Catalog_Item_Map.Substitution_Catalog_Item) {
            hasSubstitution = true;
            substitutionQty = this.state.pickListItem?.Pick_List_Catalog_Item_Map.issue_qty;
        }

        return (
            <div className={"PickListItemDetail"}>
                <div className={"mt-2 mb-2"}>
                    <OwButton
                        title={"save_and_back"}
                        fn={() => {
                            this.saveAndBack();
                        }}
                        active={this.state.saveActive}
                        disableOnActive={true}
                    />
                </div>

                <div className="row">
                    <div className={"col-12 d-flex"}>
                        <OwTitle title={this.state.pickListItem?.name || ""} disableTranslation={true} />
                        <div className={"d-flex ms-auto align-items-center"}>
                            <i
                                className={
                                    "fa-lg fad fa-sticky-note me-2 " +
                                    (this.state.pickListItem?.Pick_List_Catalog_Item_Map.issue_note?.length ? "text-warning" : "")
                                }
                            />
                            {this.state.pickListItem ? <OwItemPickStatus item={this.state.pickListItem} /> : "--"}
                        </div>
                    </div>
                </div>

                <MobilePlusMinusInput
                    readOnly={this.props.readOnly}
                    enableIncrement={totalPicked < qtyToPick}
                    enableDecrement={qtyPicked > 0}
                    incrementQtyFn={this.incrementQty}
                    name={"totalPicked"}
                    totalValue={totalPicked}
                    inputFn={this.handleTotalPicked}
                    decrementQtyFn={this.decrementQty}
                    supplierModel={this.props.supplierModel}
                    qtyToPick={qtyToPick}
                />

                {hasSubstitution && this.state.pickListItem?.Pick_List_Catalog_Item_Map.Substitution_Catalog_Item ? (
                    <div className="row mt-5">
                        <div className={"col-12 d-flex align-items-center"}>
                            <OwTitle
                                leftIconName={"fad fa-exchange"}
                                title={this.state.pickListItem?.Pick_List_Catalog_Item_Map.Substitution_Catalog_Item.sku}
                                disableTranslation={true}
                            />

                            <div className={"ms-auto"}>
                                <OwIconButton
                                    iconClass={"fa-lg fad fa-trash-alt"}
                                    iconColorClass={"text-danger"}
                                    fn={this.removeSubstitution}
                                />
                            </div>
                        </div>
                        <div className="col-12 d-flex align-items-center justify-content-center">
                            {this.props.readOnly ? null : (
                                <div>
                                    <OwIconButton
                                        iconClass={"fa-3x fas fa-plus-circle"}
                                        iconColorClass={substitutionQty < qtyToPick - qtyPicked ? "" : "text-muted"}
                                        fn={this.incrementSubQty}
                                    />
                                </div>
                            )}
                            <OwTitle
                                title={`${substitutionQty}`}
                                className={"d-inline-flex ms-5 me-5 qty-picked"}
                                disableTranslation={true}
                            />
                            {this.props.readOnly ? null : (
                                <div>
                                    <OwIconButton
                                        iconClass={"fa-3x fas fa-minus-circle "}
                                        iconColorClass={substitutionQty > 0 ? "" : "text-muted"}
                                        fn={this.decrementSubQty}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                ) : null}

                {this.state.pickListItem.has_lots ? (
                    <div className={"row mt-5"}>
                        <div className={"col-12 mb-4"}>
                            <OwTitle title={"lots"} tag={"h5"} />
                            <div className={"avail-lots-details"}>
                                <div className={"d-flex w-100"}>
                                    <div className={"name"}>
                                        <OwLabel title={"name"} isBold={true} isUnderline={true} />
                                    </div>
                                    <div className={"exp-date"}>
                                        <OwLabel title={"exp_date"} isBold={true} isUnderline={true} />
                                    </div>
                                    <div className={"available"}>
                                        <OwLabel title={"available"} isBold={true} isUnderline={true} />
                                    </div>
                                </div>
                                {this.state.lots?.map((lot) => {
                                    return (
                                        <div key={lot.guid} className={"lot-row d-flex w-100"}>
                                            <div className={"name"}>
                                                <OwButton
                                                    centerIconClass={"fas fa-plus"}
                                                    fn={() => {
                                                        this.addLot(lot);
                                                    }}
                                                    disabled={!this.canAddLot(lot)}
                                                />
                                                {lot.name}
                                            </div>
                                            <div className={"exp-date"}>{lot.exp_date ? UserService.parseDate(lot.exp_date) : "--"}</div>
                                            <div className={"available"}>
                                                {lot.qty - (lot.qty_assigned || 0)}/{lot.qty}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div>
                                <div className={"selected-lots-details"}>
                                    <div className={"d-flex w-100"}>
                                        <div className={"name"}>
                                            <OwLabel title={"name"} isBold={true} isUnderline={true} />
                                        </div>
                                        <div className={"exp-date"}>
                                            <OwLabel title={"exp_date"} isBold={true} isUnderline={true} />
                                        </div>
                                        <div className={"available"}>
                                            <OwLabel title={"available"} isBold={true} isUnderline={true} />
                                        </div>
                                    </div>
                                    {(this.state.pickListItem.Pick_List_Catalog_Item_Map.Pick_List_Item_Lot_Maps || []).map((lotMap) => {
                                        return (
                                            <div key={lotMap.guid} className={"lot-row d-flex w-100"}>
                                                <div className={"name"}>
                                                    <OwButton
                                                        className={"btn-danger"}
                                                        centerIconClass={"fas fa-trash"}
                                                        fn={() => {
                                                            this.removeLot(lotMap);
                                                        }}
                                                    />
                                                    {lotMap.Lot?.name}
                                                </div>
                                                <div className={"exp-date"}>
                                                    {lotMap.Lot?.exp_date ? UserService.parseDate(lotMap.Lot?.exp_date) : "--"}
                                                </div>
                                                <div className={"available"}>
                                                    {(lotMap.Lot?.qty || 0) - (lotMap.Lot?.qty_assigned || 0)}/{lotMap.Lot?.qty || 0}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}

                <div className={"row mt-5"}>
                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"qty"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{this.state.pickListItem?.Pick_List_Catalog_Item_Map.qty_to_pick || "--"}</div>
                    </div>

                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"loc"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{location}</div>
                    </div>

                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"sku"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{this.state.pickListItem?.sku || "--"}</div>
                    </div>

                    <div className={"col-12 mb-4"}>
                        <OwLabel title={"description"} noBottomMargin={false} isUnderline={true} isBold={true} />
                        <div>{this.state.pickListItem?.description || "--"}</div>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-12"}>
                        <OwButton title={"mark_issue"} fn={this.markIssue} />
                    </div>
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={(e: any) => {
                            this.closeModal();
                        }}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalFullContentClass"}
                        overlayClassName={"modalFullOverlayClass"}
                        style={{}}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default PickListItemDetail;
